import { AnimationBaseController, IAnimationControllerConfiguration, Inject, ModelEvents, SimpleBaseController } from "@denishussar/html5-game-engine";
import { filters } from "pixi.js";
import { AnimationContents } from "../../../AnimationContents";
import { ButtonController } from "../../Common/ButtonController";
import { UIEvents } from "../../Constants/Events";
import { LocalizationContents } from "../../LocalizationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { AppStateEnum, GameModel } from "../../Models/GameModel";
import { SettingsBarController } from "./Bars";

export interface ISettingsOptions {
    parent: SimpleBaseController,
}

export class SettingsController extends AnimationBaseController {
    $model: GameModel;
    private blur;
    constructor(
        @Inject private options: ISettingsOptions,
        @Inject private logic: GameLogic,
        @Inject private modelEvents: ModelEvents,
    ) {
        super("SettingsController");
    }

    getConfiguration(): IAnimationControllerConfiguration {
        const events = {};
        events[UIEvents.showSettings] = (show)=>{
            if(show) this.showSettings();
            else this.hideSettings();
        }
        return {
            animationContent: AnimationContents.SETTINGS_JSON,
            libraryName: "settings",
            modelWatch: {
                appState:(state)=>{
                }
            },
            modelEvents: events,
            childControllers: {
                btnOk: {
                    instanceName: "modal.btn_continue_settings",
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                            this.hideSettings();
                        }
                    }
                },
                btnTutor: {
                    instanceName: "modal.btn_tutorial",
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                            this.hideSettings();
                            this.modelEvents.dispatch(this.$model, UIEvents.showFTUE);
                        }
                    }
                },
                btnCredits: {
                    instanceName: "modal.btn_developers",
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                            this.hideSettings();
                            this.modelEvents.dispatch(this.$model, UIEvents.showCredits);
                        }
                    }
                },
                barMusic: {
                    instanceName: "modal.progress_bar_music",
                    controller: SettingsBarController,
                    model: this.$model,
                    options: {
                        bar: 1,
                    }
                },
                barFx: {
                    instanceName: "modal.progress_bar_sound",
                    controller: SettingsBarController,
                    model: this.$model,
                    options: {
                        bar: 0,
                    }
                },
            }
        }
    }
    onInitialize() {
        this.hideSettings();
        // this.blur = new filters.BlurFilter(2, 0.5, 0.25);
    }

    onResize(width: number, height: number, scale: number) {
        if (width / height > 1.0)
            this.scaleX = this.scaleY = height / scale / 1080;
        else
            this.scaleX = this.scaleY = Math.min(width / scale / 1080, height/scale/1920);

        
    }

    hideSettings() {
        const modal = this.getDisplayObjectByQuery('modal')[0];
        modal.renderable = false;
        modal.interactiveChildren = false;

        const screen = this.options.parent.$childControllers.get('screen') as SimpleBaseController;
        if (screen.display) {
            // screen.display.filters = [];
            screen.display.interactiveChildren = true;
        }
        this.$model.pause = false;
    }

    showSettings() {
        const modal = this.getDisplayObjectByQuery('modal')[0];
        modal.renderable = true;
        modal.interactiveChildren = true;
        const screen = this.options.parent.$childControllers.get('screen') as SimpleBaseController;
        // screen.display.filters = [this.blur];
        screen.display.interactiveChildren = false;
        this.$model.pause = true;
        this.localise();
    }

 
    private localise(){
        this.setTextByQuery("modal.title_settings", LocalizationContents.getText("title_settings"));
        this.setTextByQuery("modal.btn_continue_settings.button_next", LocalizationContents.getText("button_next"));
        this.setTextByQuery("modal.btn_developers.button_developers", LocalizationContents.getText("title_credits"));
        this.setTextVerticalAlignByQuery("modal.btn_continue_settings.button_next", "middle");
        this.setTextVerticalAlignByQuery("modal.btn_developers.button_developers", "middle");
    }
}